import { useNavigate } from "react-router-dom";
import { AlertTriangle, ArrowLeft } from "lucide-react";
import {Button} from "@mui/material";

export default function NotFound() {
    const navigate = useNavigate();

    const handleGoBack = () => navigate("/");

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-gray-900 p-6">
            <AlertTriangle className="text-orange-600 mb-6" size={64} />
            <h1 className="text-5xl font-bold mb-4">404</h1>
            <h2 className="text-2xl font-semibold mb-2">Page Not Found</h2>
            <p className="text-gray-600 mb-8">The page you're looking for doesn't exist.</p>
            <Button
                type="submit"
                variant="contained"
                size="large"
                sx={{
                    mt: "15px",
                    mr: "20px",
                    borderRadius: 28,
                    color: "#ffffff",
                    minWidth: "170px",
                    backgroundColor: "#FF9A01",
                }}
                onClick={handleGoBack}
            >
                <ArrowLeft className="mr-2" size={20} />
                Go Back Home
            </Button>
        </div>
    );
}
